import React from "react";
import "./questionBox.scss";

import { Stack } from "react-bootstrap";
import EastRoundedIcon from "@mui/icons-material/EastRounded";

const QuestionBox = ({
  id,
  image,
  question,
  displayed,
  handleClick,
  datetimeSending,
}) => {
  return (
    <div
      onClick={() => handleClick(id)}
      className="question-box p-2"
      style={{ backgroundColor: !displayed ? "#D4EDFF" : "#E1E1E1" }}
    >
      <Stack direction="horizontal" className="d-flex justify-content-between">
        <Stack direction="horizontal" gap={2}>
          <img src={image ?? "/no_img.png"} alt="profilo" />
          <span className="single-line">{question}</span>
        </Stack>
        <EastRoundedIcon sx={{ width: 24, height: 24 }} />
      </Stack>
      <span className="day-ago-send-question">{datetimeSending}</span>
    </div>
  );
};

export default QuestionBox;
